function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('[data-tabbed="true"]').forEach(tabGroup => tabGroup.addEventListener('keyup', this.horizontalTabOnKeyup.bind(this)));
    this.querySelectorAll('[aria-orientation="vertical"]').forEach(verticalTabGroup => verticalTabGroup.addEventListener('keyup', this.verticalTabOnKeyup.bind(this)));

  }
  verticalTabOnKeyup() {
    if (event.key == 'ArrowUp') {
      let previousButton = event.target.closest('li').previousElementSibling;
      previousButton.querySelector('summary').focus();
    }
    else if (event.key == 'ArrowDown') {
      let nextButton = event.target.closest('li').nextElementSibling;
      nextButton.querySelector('summary').focus();
    }
  }
  horizontalTabOnKeyup() {
    if (event.key == 'ArrowLeft') {
      let previousButton = event.target.closest('li').previousElementSibling;
      previousButton.querySelector('summary').focus();
    }
    else if (event.key == 'ArrowRight') {
      let nextButton = event.target.closest('li').nextElementSibling;
      nextButton.querySelector('summary').focus();
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const currentId = detailsElement.dataset.toggleId;

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    }
    else if (currentId) {
      if (detailsElement.open) {
        event.preventDefault();
        summaryElement.open = true;
      }
      else {
        let parent = summaryElement.closest('ul');
        let siblings = parent.querySelectorAll(`details:not([data-toggle-id="${currentId}"]`);
        siblings.forEach(details => details.open = false);
        summaryElement.open = true;
      }

    }
    else {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
        if (details.dataset.toggleId) {
          //don't close all tabs
        }
        else {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        }

      });
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.prevButton) {
      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    }

    if (this.nextButton) {
      if (this.isSlideVisible(this.sliderLastItem)) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.updateBNPLPrices();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateBNPLPrices();
    this.updateStickyElementOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateStickyElementOptions() {
    // Only update on product pages
    if (!location.href.includes('/products/')) return;

    // Find sticky-element in the page
    const stickyElement = document.querySelector('sticky-element');
    if (!stickyElement) return;

    // Find the sticky product option value element
    const stickyOptionValue = stickyElement.querySelector('.sticky-product-option-value');
    if (!stickyOptionValue) return;

    // Update with current selected options
    if (this.options && this.options.length > 0) {
      // Join all selected options with a separator
      const optionsText = this.options.filter(opt => opt).join(' / ');
      stickyOptionValue.textContent = optionsText;
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateBNPLPrices() {
    const paymentBlocksContainer = document.getElementsByClassName('payment-blocks-container');
    if (!paymentBlocksContainer) return;

    const blockSelector = document.querySelectorAll('.payment-block-element');

    blockSelector.forEach(e => {
      const instalments = e.querySelector('.instalments');
      const instalmentPrice = e.querySelector('.price-instalments');

      const priceAfterInstalments = this.currentVariant.price / 100 / parseInt(instalments.textContent);

      const priceAfterInstalmentsRounded = Math.round((priceAfterInstalments + Number.EPSILON) * 100) / 100
      instalmentPrice.textContent = ('$' + priceAfterInstalmentsRounded);
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {

    //Custom Code
    showNotifyButton(this.currentVariant);



    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          
          // Update sticky element price
          this.updateStickyElementPrice(source);
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  updateStickyElementPrice(sourcePrice) {
    // Only update on product pages
    if (!location.href.includes('/products/')) return;

    // Find sticky-element in the page
    const stickyElement = document.querySelector('sticky-element');
    if (!stickyElement) return;

    // Find the sticky product price container
    const stickyPriceContainer = stickyElement.querySelector('.sticky-product-price .price__container');
    if (!stickyPriceContainer) return;

    // Find the source price container
    const sourcePriceContainer = sourcePrice.querySelector('.price__container');
    if (!sourcePriceContainer) return;

    // Update the sticky price with the new price data
    stickyPriceContainer.innerHTML = sourcePriceContainer.innerHTML;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);

    // Run gallery update optional
    // if (!this.querySelector('input[name="Color"]'))  return;

    this.updateGallery();
  }

  updateGallery() {
    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);

    const currentColor = Array.from(this.querySelectorAll('input[name="Color"]')).find(radio => radio.checked)?.value;

    const colorGroupVariants = this.variantData.filter(variant => variant.options.includes(currentColor));


    colorGroupVariants.map(variant => {
      mediaGallery.setActiveMedia(`${this.dataset.section}-${variant.featured_media.id}`, true);
    })

    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
  }
}

customElements.define('variant-radios', VariantRadios);


class ProductSwatches extends HTMLElement {
  constructor() {
    super();
    this.useSessions = false;
    this.container = this.querySelector('.product-swatches__container');
    this.availableColorsContainer = this.querySelector('.product-grid-item__siblings-available');
    this.isProductPageSwatch = this.closest('.product__info-container');

    this.settings = this.setSettings();

    if (!this.settings) return;

    this.initSwatches();

    this.onHoverColorSwatch();
  }

  bindEvents() {
    const parent = this.closest("[data-card-wrapper]");
    const swatches = this.querySelectorAll("[data-row-colour] a");
    if (!swatches) return;

    var self = this;

    swatches.forEach((swatch) => {
      swatch.addEventListener("click", function (e) {
        e.preventDefault();
        fetchCardSlideData(swatch.dataset.handle)
          .then((cardSlide) => {
            console.log(cardSlide);
            console.log(self.settings);
            if (self.settings.showVendor === false) {
              const elementToRemove = cardSlide.querySelector(".card__information .caption-with-letter-spacing");
              if (elementToRemove) {
                elementToRemove.remove();
              }
              parent.classList.add("no-vendor");
            }
            parent.innerHTML = cardSlide.innerHTML;
          })
      })
    })
  }


  hideIfEmpty(hideIfEmpty) {
    if (!hideIfEmpty) return;
    const availableSwatches = this.querySelectorAll('.product-swatches__container [data-available="true"]');
    if (availableSwatches.length == 0) {
      this.classList.add("swatch-empty--hide");
    };

  }

  setSettings() {
    const settingsRawJson = this.querySelector("[data-swatches-settings]");
    if (!settingsRawJson) return null;
    return JSON.parse(settingsRawJson.innerHTML);
  }

  onHoverColorSwatch() {
    const parent = this.closest(".grid__item");
    const colorSwatches = this.querySelector('ul.color-swaches');

    if (colorSwatches) {
      const swatches = colorSwatches.querySelectorAll('li');

      swatches.forEach(x => {
        x.addEventListener('mouseover', (e) => {
          let currentNode = e.currentTarget;
          let html = ``;
          let data = JSON.parse(this.settings.data);
          let colorOption = data.options_with_values.filter(x => x.name == 'color' || x.name == 'Color')
          let colorOptionIndex = data.options.findIndex(x => x == 'color' || x == 'Color')
          let colorSelected = colorOption[0].values.filter(x => x.title.toLowerCase() == currentNode.dataset.optionName.toLowerCase())
          let imgNode = parent.querySelector('.media');
          let imgUrl = currentNode.dataset.backgroundImage;
          let size = parent.querySelector('.img_hove_sizes');

          if (imgUrl) {
            imgNode.firstChild.setAttribute('srcset', imgUrl);
            if (imgNode.childNodes.length >= 2) {
              imgNode.lastChild.remove();
            }
          }

          swatches.forEach(sw => sw.classList.remove('selected'));

          currentNode.classList.add('selected');

          data.options_with_values.forEach(x => {
            if (x.name == 'size' || x.name == 'Size') {
              data.variants.forEach((variant) => {
                if (variant.options[colorOptionIndex] == colorSelected[0].title) {
                  if (variant.available) {
                    html = html + `<li class="available" onclick="addToCart(${variant.id},'${data.handle}')"><p >${variant.option_size}</p></li>`;
                  } else {
                    html = html + `<li class="soldout"><p>${variant.option_size}</p></li>`;
                  }
                }

              });

            }

          })
          size.innerHTML = html
        })
      })
    }
  }

  initSwatches(maxIndex = 99) {
    var html = "";
    var optionsObject = {}
    var product = JSON.parse(this.settings.data);
    var colorOptions = [];
    var sizeOptions = [];

    product.options.forEach((opt, index) => {

      var optionRendered = {};
      var selectedValue = {};

      var isColor = opt == 'color' || opt == 'Color';
      if (isColor) {

        html += `<ul class="color-swaches ${isColor ? 'swatch-color' : 'swatch-size'}">`

        product.options_with_values[index].values.forEach((productOptionWithValue, indexOptionValue) => {
          var productOptionValue = productOptionWithValue.title;
          product.variants.forEach((v, vIndex) => {
            v.options.forEach((vrOpt, optVIndex) => {
              var isSoldOut = !v.available;

              if (productOptionValue == vrOpt && !optionRendered[productOptionValue]) {
                optionRendered[productOptionValue] = 1;

                html += `
                <li data-background-image="${v.image}" data-option-name="${productOptionValue}" class="${isSoldOut ? 'soldout-swatch' : ''} ${!selectedValue[opt] ? 'selected' : ''}">
                    <label  style="background-image: url(${v.image})">
                      ${isColor ? '' : productOptionValue}
                    </label>
                </li>
                `

                if (!selectedValue[opt]) {
                  selectedValue[opt] = productOptionValue;
                }
              }

            })
          })

        })
        html += `</ul>`
      }

    });

    if (html) this.container.innerHTML = html
  }


  getProductImage(product, option) {
    var image = `<img src="${product.featured_image}" loading="lazy">`;
    if (option == "colour") {
      switch (this.settings.image_type) {
        case "metafield_image":
          const metafieldImage = product.swatch_image;
          if (metafieldImage) image = metafieldImage;
          break;
        case "metafield_colour":
          const metafieldColor = product.swatch_color;
          if (metafieldColor) image = `<span class="swatch" style="background-color:${metafieldColor}"></span>`;
          break;
        case "image_swatch":
          const colourTag = product.colour;
          if (colourTag) {
            const colour = colourTag.toLowerCase().replace(/ /g, "").replace(/ /g, "-").toLowerCase();
            image = `<span data-option-name="color" data-colour-${colour.toLowerCase()}> </span>`
          } else {
            image = ``
          }
          break;
        case "featured_image":
          const featuredImage = product.featured_image;
          if (featuredImage) image = `<img src="${featuredImage}" loading="lazy">`;
          break;
        case "first_variant_image":
          const firstVariantImage = product.variants[0].image;
          if (firstVariantImage) image = `<img src="${firstVariantImage}" loading="lazy">`;
          break;
        case "last_variant_image":
          const lastVariantImg = product.variants[product.variants.length - 1].image;
          if (lastVariantImg) image = `<img src="${lastVariantImg}" loading="lazy">`;
          break;
        default:
          break;
      }
    } else {
      return product[`${option}`]
    }
    return image;
  }

  setCurrent(handle) {
    var elements = this.container.querySelectorAll(`[data-handle="${handle}"]`)
    if (handle && elements.length) {
      elements.forEach(element => {
        element.classList.add("selected");
      })
    }
  }
}
customElements.define('product-swatches', ProductSwatches);

Shopify.loadElements = function (data, selectors, parent = document) {
  Object.keys(selectors).forEach(key => {
    if (key[0] === '#') {
      data[key] = parent.getElementById(selectors[key].substring(1));
    }
    else if (key.slice(-1) === 's') {
      data[key] = parent.querySelectorAll(selectors[key]);
    }
    else {
      data[key] = parent.querySelector(selectors[key]);
    }
  });
};

Shopify.CountrySelector = function () {
  this.selectors = {
    countrySelectors: '[data-country-selector]',
    countrySelect: '.country-selector'
  };

  Shopify.loadElements(this, this.selectors);

  this.buildCountrySelectors()

};

Shopify.CountrySelector.prototype = {

  buildCountrySelectors: function () {
    const self = this;

    for (let i = 0; i < self.countrySelectors.length; i++) {
      let placeholder = self.countrySelectors[i];
      let selector = self.countrySelect.cloneNode(true);
      placeholder.appendChild(selector);
    }

  }

};

new Shopify.CountrySelector();

class StickyElement extends HTMLElement {
  constructor() {
    super();
    this.contentWrapper = null;
    this.originalHeight = 0;
    this.stickyHeader = null;
    this.headerHeight = 0;
    
    this.init();
  }

  init() {
    // Get sticky header element and calculate its height
    this.getStickyHeader();
    
    // Wrap children in a container for absolute positioning
    this.wrapContent();
    
    // Setup quantity input listener
    this.setupQuantityListener();
    
    // Calculate and store the height
    this.calculateHeight();
    
    // Create intersection observer with header height adjustment
    this.observerOptions = {
      root: null,
      rootMargin: `-${this.headerHeight}px 0px 0px 0px`,
      threshold: 0
    };
    
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      this.observerOptions
    );
    
    // Start observing the element
    this.observer.observe(this);
    
    // Add styles to the element when sticky
    this.setupStyles();
    
    // Recalculate on window resize
    window.addEventListener('resize', debounce(() => {
      this.getStickyHeader();
      this.calculateHeight();
      this.updateObserver();
    }, 250));
  }

  setupQuantityListener() {
    // Find the quantity input within this sticky-element
    const quantityInput = this.querySelector('quantity-input > input');
    
    if (!quantityInput) return;
    
    // Add change event listener
    quantityInput.addEventListener('change', this.handleQuantityChange.bind(this));
    
    // Also add input event for real-time updates
    quantityInput.addEventListener('input', this.handleQuantityChange.bind(this));
    
    // Initialize button state based on current value
    this.handleQuantityChange({ target: quantityInput });
  }

  handleQuantityChange(event) {
    const input = event.target;
    const value = parseInt(input.value) || 0;
    
    // Find all quantity buttons in this sticky-element
    const quantityButtons = this.querySelectorAll('.quantity__button');
    const minusButton = this.querySelector('.quantity__button[name="minus"]');
    
    if (value > 1) {
      // Remove disabled from all quantity buttons
      quantityButtons.forEach(button => {
        button.removeAttribute('disabled');
      });
    } else {
      // Add disabled to minus button when value is 1 or less
      if (minusButton) {
        minusButton.setAttribute('disabled', 'disabled');
      }
    }
  }

  getStickyHeader() {
    // Get the sticky header element
    this.stickyHeader = document.querySelector('#shopify-section-header');
    
    if (this.stickyHeader) {
      this.headerHeight = this.stickyHeader.offsetHeight;
    } else {
      this.headerHeight = 0;
    }
  }

  updateObserver() {
    // Recreate observer with updated header height
    if (this.observer) {
      this.observer.disconnect();
    }
    
    this.observerOptions = {
      root: null,
      rootMargin: `-${this.headerHeight}px 0px 0px 0px`,
      threshold: 0
    };
    
    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      this.observerOptions
    );
    
    this.observer.observe(this);
  }

  wrapContent() {
    // Create wrapper for content
    this.contentWrapper = document.createElement('div');
    this.contentWrapper.classList.add('sticky-element__wrapper');
    
    // Move all children into the wrapper
    while (this.firstChild) {
      this.contentWrapper.appendChild(this.firstChild);
    }
    
    // Add wrapper back to sticky-element
    this.appendChild(this.contentWrapper);
  }

  calculateHeight() {
    // Temporarily remove any fixed positioning to get accurate height
    const wasSticky = this.classList.contains('is-sticky');
    if (wasSticky) {
      this.classList.remove('is-sticky');
    }
    
    // Get the natural height of the content
    this.originalHeight = this.contentWrapper.offsetHeight;
    
    // Set the height on the sticky-element to prevent layout shift
    this.style.minHeight = `${this.originalHeight}px`;
    
    // Restore sticky state if it was active
    if (wasSticky) {
      this.classList.add('is-sticky');
    }
  }

  setupStyles() {
    // Create style element for sticky state
    const style = document.createElement('style');
    style.textContent = `
      
    `;
    
    // Only add style once
    if (!document.querySelector('#sticky-element-styles')) {
      style.id = 'sticky-element-styles';
      document.head.appendChild(style);
    }
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Element is in view - remove sticky state
        this.classList.remove('is-sticky');
      } else {
        // Element is out of view - add sticky state
        this.classList.add('is-sticky');
      }
    });
  }

  disconnectedCallback() {
    // Clean up observer when element is removed
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

customElements.define('sticky-element', StickyElement);
document.addEventListener("DOMContentLoaded", () => {
  const lockScroll = () => {
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;
    document.body.dataset.scrollY = scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100%';
  };
  const btn = document.querySelector(".product-popup-modal__button");
  if (btn) {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      lockScroll();
    });
  }
})
